// extracted by mini-css-extract-plugin
export default {"logoutButton":"logout_logoutButton__pepgV"};